<div class="side-nav-header">
  <button type="button" (click)="onMainNavCollapse()" [title]="expandButtonTitle()">
    <img src="/assets/img/logo/avux-lg-green.svg" class="logo-large" alt="Logo" *ngIf="!navigationCollapsed" [@inOutAnimation]>
    <img src="/assets/img/logo/avux-sm-green.svg" class="logo-small" alt="Logo" *ngIf="navigationCollapsed" [@inOutAnimation]>
  </button>
</div>

<nav class="side-nav-content" outsideClick (outsideClick)="onOutsideClick()">

  <ul>

    <li>
      <a [routerLink]="['/']" [ngClass]="{'is-active' : currentModule === 'Dashboard'}" [attr.title]="moduleTitle(homepageTitle)">
        <i class="fa-regular fa-house-window nav-icon"></i>
        <span>{{'common.home' | translate}}</span>
      </a>
    </li>


    <span class="custom-spinner" *ngIf="loading">
      <loading-spinner></loading-spinner>
    </span>

    <li *ngFor="let item of sideNavService.navigation; index as i">

      <a [routerLink]="item.page" *ngIf="item.page" [ngClass]="{ 'is-active': currentModule === item?.title }" [attr.title]="moduleTitle(item.title)">
        <i class="nav-icon" [ngClass]="item.icon"></i>
        <span>{{item.title}}</span>
        <span *ngIf="item.ID == 140 && (moveNotificationCount | async)" class="badge badge-primary ml-1">{{moveNotificationCount | async}}</span>
      </a>

      <ng-container *ngIf="!item.page && item.childMenu">

        <button type="button" (click)="onCollapse(item, $event)" [ngClass]="{'is-active':currentModule === item?.title}"
          [attr.title]="moduleTitle(item.title)">
          <i class="nav-icon" [ngClass]="item.icon"></i>
          <span>{{item.title}}</span>
          <i class="fa-regular fa-chevron-right ngx-collapse-toggle" [ngClass]="{'open': !item.collapse}"></i>


          <!-- Tiny nav dropdown -->
          <div class="ngx-collapse-dropdown" *ngIf="item?.childMenu && !item.collapse" [ngStyle]="{'top': dropdownTopPosition+'px'}" boundingBox>
            <ul>
              <li *ngFor="let child of item?.childMenu">
                <a [routerLink]="[child.page]" (click)="dropdownLinkClick($event)">
                  {{child.title}}
                </a>
              </li>
            </ul>
          </div>

        </button>

        <div class="ngx-collapse" [collapse]="navigationCollapsed ? true : item.collapse" [isAnimated]="true">
          <ul>
            <li *ngFor="let child of item.childMenu">
              <a [routerLink]="[child.page]">
                <span>
                  {{child.title}}
                </span>
              </a>
            </li>
          </ul>
        </div>

      </ng-container>


    </li>


  </ul>

  <ul class="additional-menu">

    <li>
      <a class="dropdown-item" [routerLink]="['/my-account']">
        {{ 'user.my_account.my_account' | translate }}
      </a>
    </li>

    <!-- <li *ngIf="isOrgAdmin">
      <a class="dropdown-item" [routerLink]="['/org-management']">
        {{ 'organization.organization_management' | translate }}
      </a>
    </li> -->

    <li>
      <button type="button" (click)="openLogOutModal()">{{'login.logout' | translate}}</button>
    </li>

  </ul>

</nav>


<!-- <div class="side-nav-footer">
  <button type="button" class="collapse-btn" (click)="onMainNavCollapse()" [attr.title]="expandButtonTitle()">
    <div class="icon-container shadow-sm border">
      <i class="fa-regular fa-chevron-left"></i>
    </div>
  </button>
</div> -->
